import { useStepperContext } from '@ahmdigital/ui';

const useActiveIndex = () => {
  const { activeStep, steps } = useStepperContext();
  const activeIndex = steps.indexOf(activeStep);
  return activeIndex;
};

export default useActiveIndex;
